import type { I18nOptions } from "vue-i18n";
import { CONFIG } from "@shared/config";
import { merge } from "ts-deepmerge";
import { normalizeLocale } from "@shared/utils/locale/normalize";

const {
  application: {
    initialization: {
      localization: {
        language: { supported, defaultValue },
      },
    },
  },
} = CONFIG;

export const buildMessages = async (
  fallbackLocale: Record<string, string[]>,
): Promise<I18nOptions["messages"]> => {
  const messages: I18nOptions["messages"] = {};

  // Remap to fallback locales
  const remappedSupportedLocales = supported.map((locale) => {
    if (fallbackLocale[locale]) {
      return fallbackLocale[locale][0];
    }

    return locale;
  });

  for (const locale of remappedSupportedLocales) {
    const { locale: normalizedLocale } = normalizeLocale(locale);

    const modules = import.meta.glob(
      ["@/i18n/*.json", "./default-messages/*.json"],
      {
        eager: false,
      },
    );

    const [defaultMessages = {}, appMessages = {}] = await Promise.all([
      modules[
        `../../libs/shared/app/i18n/default-messages/${normalizedLocale}.json`
      ]?.(),
      modules[`/src/i18n/${normalizedLocale}.json`]?.(),
    ]);

    messages[normalizedLocale || defaultValue] = merge.withOptions(
      { mergeArrays: false, allowUndefinedOverrides: false },
      // @ts-expect-error import is of type unknown, but we know it's our message format.
      defaultMessages,
      appMessages,
    );
  }

  return messages;
};
